import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  CreateSavedBankAddressRequestDto,
  CreateSavedBankAddressResponseDto,
} from '../model';

const createSavedBankAddress = async (
  args: CreateSavedBankAddressRequestDto,
  options?: RequestHandlerOptions
): Promise<CreateSavedBankAddressResponseDto> => {
  const request = () => apiClient.post('/operations/bank/template', args);

  const response = await handleRequest<CreateSavedBankAddressResponseDto>(
    request,
    options
  );

  return response.data;
};

export { createSavedBankAddress };
